import { Scrollbar } from "react-scrollbars-custom";
import SimpleTable from "@components/Table/SimpleTable";
import { TableContext } from "@components/Table/TableContext";
import { FC, memo, useMemo } from "react";
import { iTableConfigItem } from "@components/Table/TableConfig";

const FeedbackTable: FC<{
    config: iTableConfigItem[];
    itemsCount: number;
    onRowClick?: (index: number) => void;
    activeRowsIndexes?: number[];
    rowHeight?: number | 'auto';
    rowMinHeight?: number;
}> = ({
    config,
    itemsCount,
    onRowClick,
    rowHeight = 40,
    rowMinHeight = 40,
    activeRowsIndexes,
}) => {

    const providerValue = useMemo(
        () => ({ config }),
        [config]
    );

    return (
        <TableContext.Provider value={providerValue}>
            <Scrollbar>
                <SimpleTable
                    isLoading={false}
                    rowsCount={itemsCount}
                    style={{ padding: 0 }}
                    onRowClick={onRowClick}
                    headStyle={{
                        height: 45,
                    }}
                    rowStyle={{
                        height: rowHeight,
                        minHeight: rowMinHeight,
                        alignItems: "center",
                    }}
                    activeRowsIndexes={activeRowsIndexes}
                />
            </Scrollbar>
        </TableContext.Provider>
    );
}

export default memo(FeedbackTable);